import { useSelector } from "react-redux";

export const AllRoles = {
  webUser: "Dispatcher.WebUser",
  webUserBasic: "Dispatcher.WebUser.Basic",
  webUserStandard: "Dispatcher.WebUser.Standard",
  webUserAdvanced: "Dispatcher.WebUser.Advanced",
  webUserBroker: "Dispatcher.WebUser.Broker",
  loadDownloader: "Dispatcher.LoadDownloader",
  dev: "Dispatcher.Developer",
  mobileUser: "Dispatcher.MobileUser",
};

export const useIsDev = () => {
  const user = useSelector((state) => state.user);
  return user.data?.roles?.includes(AllRoles.dev);
};

export const useIsWebUser = () => {
  const user = useSelector((state) => state.user);
  return (
    user.data?.roles?.includes(AllRoles.webUserBasic) ||
    user.data?.roles?.includes(AllRoles.webUserStandard) ||
    user.data?.roles?.includes(AllRoles.webUserAdvanced)
  );
};

export const useIsAdminOrDev = () => {
  const user = useSelector((state) => state.user);
  return (
    (user.data?.roles?.includes(AllRoles.webUserStandard) || user.data?.roles?.includes(AllRoles.webUserAdvanced)) &&
    (user.data?.roles?.includes(AllRoles.loadDownloader) || user.data?.roles?.includes(AllRoles.dev))
  );
};

export const useAreFeaturesUnlocked = () => {
  const user = useSelector((state) => state.user);
  return user.data?.roles?.includes(AllRoles.webUserStandard) || user.data?.roles?.includes(AllRoles.webUserAdvanced);
};

export const useCanAccessLoadFinder = () => {
  const user = useSelector((state) => state.user);
  const roles = user.data?.roles || [];
  // Brokers don't post trucks — hide the Load finder page from them.
  if (roles.includes(AllRoles.webUserBroker)) return false;
  return roles.includes(AllRoles.webUserStandard) || roles.includes(AllRoles.webUserAdvanced);
};

export const useCanAccessChatAssistant = () => {
  const user = useSelector((state) => state.user);
  const roles = user.data?.roles || [];
  return roles.includes(AllRoles.webUserStandard) || roles.includes(AllRoles.webUserAdvanced) || roles.includes(AllRoles.webUserBroker);
};

export const useIsBroker = () => {
  const user = useSelector((state) => state.user);
  return user.data?.roles?.includes(AllRoles.webUserBroker);
};

export const useIsLoadDownloader = () => {
  const user = useSelector((state) => state.user);
  return user.data?.roles?.includes(AllRoles.loadDownloader);
};
